<template>
  <div>
    <Header />

    <div class="bg-light">
      <div class="container">
        <div class="section-header-breadcrumb">
          <h2 class="title-page">{{ $t("contact.title") }}</h2>
          <a href="#">{{ $t("contact.breadcrumb_home") }}</a> <i class="ti ti-angle-right"></i>
          <span>{{ $t("contact.title") }}</span>
        </div>

        <div class="row justify-content-center mt-5">
          <div class="col-lg-6">
            <h2 class="h2-title text-center">{{ $t("contact.title") }}</h2>
            <p class="text-center font-16" v-html="$sanitize.sanitizeI18nContent($t('contact.intro'))"></p>
          </div>
        </div>

        <div class="row mt-3 align-items-center justify-content-center">
          <div v-if="isVeterinaire" class="row justify-content-center">
            <template v-for="deleg in delegues" :key="deleg.id">
              <div class="col-lg-4 mb-4">
                <div class="box-contact bg-white border-0 p-4 h-170" style="min-height: 165px">
                  <p class="font-bold blue-color">{{ $t("contact.delegate_title") }}</p>
                  <ul>
                    <li>
                      <img :src="user" /><span>{{ deleg.lastName }}</span>
                    </li>
                    <li>
                      <img :src="phone" /><span>{{ deleg.phoneNumber }}</span>
                    </li>
                    <li>
                      <img :src="envelope" /><span>{{ deleg.email }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </template>
            <template v-for="(service, index) in services" :key="index">
              <div class="col-lg-4 mb-4">
                <div class="box-contact bg-white border-0 p-4 h-170" style="min-height: 165px">
                  <p class="font-bold blue-color">{{ service.titre }} :</p>
                  <ul>
                    <li>
                      <img :src="phone" /><span>{{ service.telephone }}</span>
                    </li>
                    <li>
                      <img :src="envelope" /><span>{{ service.email }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </template>
          </div>
          <div v-else class="col-lg-9">
            <div class="bg-white align-items-center round-10 p-4 d-flex justify-content-center gap-5">
              <div v-if="services.length > 0">
                <div
                  v-for="service in services.filter(s => s.titre === 'Service client')"
                  :key="service.id"
                  class="d-flex justify-content-center gap-5"
                >
                  <p class="mb-0 font-18">{{ service.titre }}</p>
                  <p class="mb-0 font-18">
                    <img :src="phone" /><span class="ps-3">{{ service.telephone }}</span>
                  </p>
                  <p class="mb-0 font-18">
                    <img :src="envelope" /><span class="ps-3">{{ service.email }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-9 mt-5 mb-5">
            <div class="box-contact bg-white border-0 p-5 mb-5">
              <h4 class="text-center font-bold font-25 blue-color">{{ $t("contact.form_title") }}</h4>
              <p class="text-center dark-color-1">
                <i>{{ $t("contact.required_fields") }}</i>
              </p>

              <div class="row">
                <div class="col-lg-6">
                  <div class="form-input">
                    <input
                      v-model="form.nom"
                      type="text"
                      class="form-control"
                      :placeholder="$t('contact.placeholders.name')"
                    />
                    <span v-if="errorName" class="error-message mb-4">{{ errorName }}</span>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-input">
                    <input
                      v-model="form.email"
                      type="email"
                      class="form-control"
                      :placeholder="$t('contact.placeholders.email')"
                    />
                    <span v-if="errorEmail" class="error-message mb-4">{{ errorEmail }}</span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <div class="form-input">
                    <select v-model="form.objet" class="form-control">
                      <option value="">{{ $t("contact.placeholders.object") }}</option>
                      <option v-for="obj in objets" :key="obj.id" :value="obj.id">{{ obj.titre }}</option>
                    </select>
                    <span v-if="errorObjet" class="error-message mb-4">{{ errorObjet }}</span>
                  </div>
                </div>
              </div>

              <div v-if="form.objet == '1'">
                <div class="form-input">
                  <input
                    v-model="form.update_order_number"
                    type="text"
                    class="form-control"
                    :placeholder="$t('contact.placeholders.order_number')"
                  />
                  <span v-if="errorCmdNumber" class="error-message mb-4">{{ errorCmdNumber }}</span>
                </div>

                <div class="check-element mt-4">
                  <h4 class="font-16 blue-color mb-3">{{ $t("contact.sections.modification_elements") }}</h4>

                  <div class="d-flex gap-4">
                    <div class="custom-checkbox">
                      <label>
                        <input type="checkbox" v-model="form.update_billing_address" />
                        {{ $t("contact.checkboxes.billing_address") }}</label
                      >
                    </div>
                    <div class="custom-checkbox">
                      <label>
                        <input type="checkbox" v-model="form.update_delivery_address" />
                        {{ $t("contact.checkboxes.delivery_address") }}</label
                      >
                    </div>
                    <div class="custom-checkbox">
                      <label>
                        <input type="checkbox" v-model="form.update_email" />
                        {{ $t("contact.checkboxes.email") }}</label
                      >
                    </div>
                    <div class="custom-checkbox">
                      <label>
                        <input type="checkbox" v-model="form.update_phone" />
                        {{ $t("contact.checkboxes.phone") }}</label
                      >
                    </div>
                    <div class="custom-checkbox">
                      <label>
                        <input type="checkbox" v-model="form.update_lastname" />
                        {{ $t("contact.checkboxes.lastname") }}</label
                      >
                    </div>

                    <div class="custom-checkbox">
                      <label>
                        <input type="checkbox" v-model="form.update_firstname" />
                        {{ $t("contact.checkboxes.firstname") }}</label
                      >
                    </div>
                  </div>
                </div>
                <div class="form-block mb-3">
                  <div v-if="form.update_billing_address">
                    <h5 class="blue-color font-bold font-16 mt-5 mb-4">
                      {{ $t("contact.sections.billing_address") }}
                    </h5>

                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">{{ $t("contact.labels.address") }}</label>
                          <input type="text" class="form-control" v-model="form.update_billing_address_address" />
                          <span v-if="errorDemandeAdressFacturation" class="error-message mb-1">{{
                            errorDemandeAdressFacturation
                          }}</span>
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">{{ $t("contact.labels.address_complement") }}</label>
                          <input type="text" class="form-control" v-model="form.update_billing_address_address2" />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">{{ $t("contact.labels.address_complement2") }}</label>
                          <input type="text" class="form-control" v-model="form.update_billing_address_address3" />
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">{{ $t("contact.labels.postal_code") }}</label>
                          <input type="text" class="form-control" v-model="form.update_billing_address_postcode" v-only-digits />
                          <span v-if="errorDemandeCodePostalFacturation" class="error-message mb-1">{{
                            errorDemandeCodePostalFacturation
                          }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">{{ $t("contact.labels.city") }}</label>
                          <input type="text" class="form-control" v-model="form.update_billing_address_city" />
                          <span v-if="errorDemandeVilleFacturation" class="error-message mb-1">{{
                            errorDemandeVilleFacturation
                          }}</span>
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">{{ $t("contact.labels.country") }}</label>
                          <input type="text" class="form-control" v-model="form.update_billing_address_pays" />
                          <span v-if="errorDemandePaysFacturation" class="error-message mb-1">{{
                            errorDemandePaysFacturation
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="form.update_delivery_address">
                    <h5 class="blue-color font-bold font-16 mt-5 mb-4">
                      {{ $t("contact.sections.delivery_address") }}
                    </h5>

                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">{{ $t("contact.labels.address") }}</label>
                          <input type="text" class="form-control" v-model="form.update_delivery_address_address" />
                          <span v-if="errorDemandeAdressLivraison" class="error-message mb-1">{{
                            errorDemandeAdressLivraison
                          }}</span>
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">{{ $t("contact.labels.address_complement") }}</label>
                          <input type="text" class="form-control" v-model="form.update_delivery_address_address2" />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">{{ $t("contact.labels.address_complement2") }}</label>
                          <input type="text" class="form-control" v-model="form.update_delivery_address_address3" />
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">{{ $t("contact.labels.postal_code") }}</label>
                          <input type="text" class="form-control" v-model="form.update_delivery_address_postcode" v-only-digits />
                          <span v-if="errorDemandeCodePostalLivraison" class="error-message mb-1">{{
                            errorDemandeCodePostalLivraison
                          }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">{{ $t("contact.labels.city") }}</label>
                          <input type="text" class="form-control" v-model="form.update_delivery_address_city" />
                          <span v-if="errorDemandeVilleLivraison" class="error-message mb-1">{{
                            errorDemandeVilleLivraison
                          }}</span>
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">{{ $t("contact.labels.country") }}</label>
                          <input type="text" class="form-control" v-model="form.update_delivery_address_pays" />
                          <span v-if="errorDemandePaysLivraison" class="error-message mb-1">{{
                            errorDemandePaysLivraison
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="form.update_email">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">{{ $t("contact.labels.email") }}</label>
                          <input type="email" class="form-control" v-model="form.update_email_email" />
                          <span v-if="errorDemandeEmail" class="error-message mb-1">{{ errorDemandeEmail }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="form.update_phone">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">{{ $t("contact.labels.phone") }}</label>
                          <input type="tel" class="form-control" v-model="form.update_phone_phone" v-only-digits />
                          <span v-if="errorDemandePhone" class="error-message mb-1">{{ errorDemandePhone }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="form.update_lastname">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">{{ $t("contact.labels.lastname") }}</label>
                          <input type="tel" class="form-control" v-model="form.update_lastname_lastname" />
                          <span v-if="errorDemandeNom" class="error-message mb-1">{{ errorDemandeNom }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="form.update_firstname">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-input">
                          <label class="label-control">{{ $t("contact.labels.firstname") }}</label>
                          <input type="tel" class="form-control" v-model="form.update_firstname_firstname" />
                          <span v-if="errorDemandePrenom" class="error-message mb-1">{{ errorDemandePrenom }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="form.objet == '3'">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-input">
                      <label class="label-control">{{ $t("contact.placeholders.phone") }} :</label>
                      <input type="tel" class="form-control" v-model="form.phone" placeholder="" v-only-digits />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-input">
                    <textarea
                      v-model="form.message"
                      class="form-control"
                      rows="8"
                      :placeholder="$t('contact.placeholders.message')"
                    ></textarea>
                    <span v-if="errorMessage" class="error-message mb-4">{{ errorMessage }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <button
                class="btn btn-orange w-25"
                ref="sendButton"
                @click.prevent="EnvoiContact"
                v-html="$sanitize.sanitizeI18nContent(buttonContent)"
              ></button>
            </div>

            <div
              v-if="successEnvoiMessage"
              class="modal fade show d-block"
              id="successModal"
              tabindex="-1"
              role="dialog"
              aria-labelledby="successModalLabel"
              aria-hidden="true"
              style="background-color: rgba(0, 0, 0, 0.5)"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content bg-white round-10 p-4">
                  <div class="modal-header border-0">
                    <h5 class="modal-title font-bold blue-color" id="successModalLabel">Succès</h5>
                    <button
                      type="button"
                      class="btn-close"
                      @click="successEnvoiMessage = ''"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="modal-body text-center">
                    <span class="success-message font-16">Votre message a été envoyé avec succès</span>
                  </div>
                  <div class="modal-footer border-0 justify-content-center">
                    <button type="button" class="btn btn-orange" @click="successEnvoiMessage = ''">Fermer</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="service-list p-60">
      <div class="container">
        <div class="content col-sm-12 col-md-12 col-lg-12">
          <Service />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Header from "@/components/Header.vue";
  import Footer from "@/components/Footer.vue";
  import Service from "@/components/Service.vue";
  import phone from "@/assets/images/phone.svg";
  import user from "@/assets/images/user.svg";
  import envelope from "@/assets/images/envelope.svg";
  import { useContactsStore } from "@/stores/contactStore";
  import FormContactService from "@/services/formContactService";
  import AuthService from "@/services/authService";
  export default {
    components: {
      Header,
      Footer,
      Service,
    },
    data() {
      return {
        phone,
        user,
        envelope,
        serviceStore: null,

        form: {
          nom: "",
          email: "",
          objet: "",
          objetInfo: "",
          message: "",
          channel: "/api/v2/shop/channels/supplyvet",

          update_order_number: "",

          update_billing_address: false,
          update_delivery_address: false,
          update_email: false,
          update_phone: false,
          update_lastname: false,
          update_firstname: false,

          update_billing_address_address: "",
          update_billing_address_address2: "",
          update_billing_address_address3: "",
          update_billing_address_postcode: "",
          update_billing_address_city: "",
          update_billing_address_pays: "",

          update_delivery_address_address: "",
          update_delivery_address_address2: "",
          update_delivery_address_address3: "",
          update_delivery_address_postcode: "",
          update_delivery_address_city: "",
          update_delivery_address_pays: "",

          update_email_email: "",
          update_phone_phone: "",
          update_lastname_lastname: "",
          update_firstname_firstname: "",
        },

        errorName: "",
        errorEmail: "",
        errorObjet: "",
        errorCmdNumber: "",
        errorMessage: "",
        errorDemandeAdressFacturation: "",
        errorDemandeCodePostalFacturation: "",
        errorDemandeVilleFacturation: "",
        errorDemandePaysFacturation: "",
        errorDemandeAdressLivraison: "",
        errorDemandeCodePostalLivraison: "",
        errorDemandeVilleLivraison: "",
        errorDemandePaysLivraison: "",
        errorDemandeEmail: "",
        errorDemandePhone: "",
        errorDemandeNom: "",
        errorDemandePrenom: "",
        canStoreDemande: true,
        isLoadingDemande: false,
        successEnvoiMessage: "",
        buttonContent: "",
      };
    },
    computed: {
      services() {
        return useContactsStore()
          .Services.slice()
          .sort((a, b) => a.id - b.id);
      },
      delegues() {
        return useContactsStore()
          .Delegues.slice()
          .sort((a, b) => a.id - b.id);
      },
      objets() {
        return useContactsStore()
          .Objets.slice()
          .sort((a, b) => a.id - b.id);
      },
      loading() {
        return useContactsStore().loading;
      },
      isVeterinaire() {
        return AuthService.isVeterinaire();
      },
    },
    created() {
      this.contactStore = useContactsStore();
      this.contactStore.fetchServices_Delegues();
      this.contactStore.fetchObjets();
      this.buttonContent = this.$t("contact.buttons.send");
    },
    methods: {
      EnvoiContact() {
        this.errorName = "";
        this.errorEmail = "";
        this.errorObjet = "";
        this.errorCmdNumber = "";
        this.errorMessage = "";
        this.errorDemandeAdressFacturation = "";
        this.errorDemandeCodePostalFacturation = "";
        this.errorDemandeVilleFacturation = "";
        this.errorDemandePaysFacturation = "";
        this.errorDemandeAdressLivraison = "";
        this.errorDemandeCodePostalLivraison = "";
        this.errorDemandeVilleLivraison = "";
        this.errorDemandePaysLivraison = "";
        this.errorDemandeEmail = "";
        this.errorDemandePhone = "";
        this.errorDemandeNom = "";
        this.errorDemandePrenom = "";
        this.canStoreDemande = true;
        this.isLoadingDemande = true;
        this.buttonContent =
          '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ' +
          this.$t("contact.buttons.sending");
        this.CheckValidateDemande();
        if (this.canStoreDemande) {
          const currentDate = new Date().toISOString();
          const channel = this.isVeterinaire ? "/api/v2/shop/channels/supplyvet" : "/api/v2/shop/channels/esupplyvet";
          const formData = {
            nom: this.form.nom,
            email: this.form.email,
            message: this.form.message,
            channel: channel,
            sendedAt: currentDate,
            objetInfo: "/api/v2/shop/form-contacts-objets/" + this.form.objet,
            additionalInfo: this.getAdditionalInfo(),
          };
          FormContactService.sendFormContact(formData, this.isVeterinaire)
            .then(res => {
              if (res.data && res.data.id) {
                this.ResetFormDemande();
                this.successEnvoiMessage = this.$t("contact.success_message");
                setTimeout(() => {
                  this.successEnvoiMessage = "";
                }, 5000);
              }
              this.buttonContent = this.$t("contact.buttons.send");
              this.isLoadingDemande = false;
            })
            .catch(error => {
              console.error("Form submission failed: ", error);
              console.error("Error details: ", error.response ? error.response.data : error.message);
              this.isLoadingDemande = false;
              this.buttonContent = this.$t("contact.buttons.send");
            });
        } else {
          this.isLoadingDemande = false;
          this.buttonContent = this.$t("contact.buttons.send");
        }
      },
      getAdditionalInfo() {
        let additionalInfo = "";
        if (this.form.objet == "1") {
          additionalInfo += `Numéro de commande: ${this.form.update_order_number}\n`;
          if (this.form.update_billing_address) {
            additionalInfo += `Adresse de facturation: ${this.form.update_billing_address_address}, ${this.form.update_billing_address_address2}, ${this.form.update_billing_address_address3}, ${this.form.update_billing_address_postcode}, ${this.form.update_billing_address_city}, ${this.form.update_billing_address_pays}\n`;
          }
          if (this.form.update_delivery_address) {
            additionalInfo += `Adresse de livraison: ${this.form.update_delivery_address_address}, ${this.form.update_delivery_address_address2}, ${this.form.update_delivery_address_address3}, ${this.form.update_delivery_address_postcode}, ${this.form.update_delivery_address_city}, ${this.form.update_delivery_address_pays}\n`;
          }
          if (this.form.update_email) {
            additionalInfo += `Email: ${this.form.update_email_email}\n`;
          }
          if (this.form.update_phone) {
            additionalInfo += `Téléphone: ${this.form.update_phone_phone}\n`;
          }
          if (this.form.update_lastname) {
            additionalInfo += `Nom: ${this.form.update_lastname_lastname}\n`;
          }
          if (this.form.update_firstname) {
            additionalInfo += `Prénom: ${this.form.update_firstname_firstname}\n`;
          }
        }
        if (this.form.objet == "3" && this.form.phone) {
          additionalInfo += `Téléphone: ${this.form.phone}\n`;
        }
        return additionalInfo;
      },
      CheckValidateDemande() {
        if (this.form.nom == "") {
          this.errorName = this.$t("contact.errors.field_required", { field: "nom" });
          this.canStoreDemande = false;
        }

        if (this.form.email == "") {
          this.errorEmail = this.$t("contact.errors.field_required", { field: "email" });
          this.canStoreDemande = false;
        } else {
          const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!regex.test(this.form.email)) {
            this.errorEmail = this.$t("contact.errors.email_invalid");
            this.canStoreDemande = false;
          }
        }

        if (this.form.objet == "") {
          this.errorObjet = this.$t("contact.errors.field_required", { field: "objet" });
          this.canStoreDemande = false;
        }

        if (this.form.objet == "1" && this.form.update_order_number == "") {
          this.errorCmdNumber = this.$t("contact.errors.field_required", { field: "numéro de commande" });
          this.canStoreDemande = false;
        }

        if (this.form.message == "") {
          this.errorMessage = this.$t("contact.errors.field_required", { field: "message" });
          this.canStoreDemande = false;
        }

        if (this.form.update_billing_address) {
          if (this.form.update_billing_address_address == "") {
            this.errorDemandeAdressFacturation = this.$t("contact.errors.address_required", { type: "facturation" });
            this.canStoreDemande = false;
          }
          if (this.form.update_billing_address_postcode == "") {
            this.errorDemandeCodePostalFacturation = this.$t("contact.errors.postal_code_required", {
              type: "facturation",
            });
            this.canStoreDemande = false;
          }
          if (this.form.update_billing_address_city == "") {
            this.errorDemandeVilleFacturation = this.$t("contact.errors.city_required", { type: "facturation" });
            this.canStoreDemande = false;
          }
          if (this.form.update_billing_address_pays == "") {
            this.errorDemandePaysFacturation = this.$t("contact.errors.country_required", { type: "facturation" });
            this.canStoreDemande = false;
          }
        }

        if (this.form.update_delivery_address) {
          if (this.form.update_delivery_address_address == "") {
            this.errorDemandeAdressLivraison = this.$t("contact.errors.address_required", { type: "livraison" });
            this.canStoreDemande = false;
          }
          if (this.form.update_delivery_address_postcode == "") {
            this.errorDemandeCodePostalLivraison = this.$t("contact.errors.postal_code_required", {
              type: "livraison",
            });
            this.canStoreDemande = false;
          }
          if (this.form.update_delivery_address_city == "") {
            this.errorDemandeVilleLivraison = this.$t("contact.errors.city_required", { type: "livraison" });
            this.canStoreDemande = false;
          }
          if (this.form.update_delivery_address_pays == "") {
            this.errorDemandePaysLivraison = this.$t("contact.errors.country_required", { type: "livraison" });
            this.canStoreDemande = false;
          }
        }

        if (this.form.update_email) {
          if (this.form.update_email_email == "") {
            this.errorDemandeEmail = this.$t("contact.errors.field_required", { field: "email" });
            this.canStoreDemande = false;
          } else {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!regex.test(this.form.update_email_email)) {
              this.errorDemandeEmail = this.$t("contact.errors.email_invalid");
              this.canStoreDemande = false;
            }
          }
        }

        if (this.form.update_phone && this.form.update_phone_phone == "") {
          this.errorDemandePhone = this.$t("contact.errors.field_required", { field: "téléphone fixe" });
          this.canStoreDemande = false;
        }

        if (this.form.update_lastname && this.form.update_lastname_lastname == "") {
          this.errorDemandeNom = this.$t("contact.errors.field_required", { field: "nom" });
          this.canStoreDemande = false;
        }

        if (this.form.update_firstname && this.form.update_firstname_firstname == "") {
          this.errorDemandePrenom = this.$t("contact.errors.field_required", { field: "prénom" });
          this.canStoreDemande = false;
        }

        if (!this.canStoreDemande) {
          this.isLoadingDemande = false;
          this.buttonContent = this.$t("contact.buttons.send");
        }
      },
      ResetFormDemande() {
        this.form = {
          nom: "",
          email: "",
          objet: "",
          objetInfo: "",
          message: "",
          channel: "/api/v2/shop/channels/supplyvet",

          update_order_number: "",

          update_billing_address: false,
          update_delivery_address: false,
          update_email: false,
          update_phone: false,
          update_lastname: false,
          update_firstname: false,

          update_billing_address_address: "",
          update_billing_address_address2: "",
          update_billing_address_address3: "",
          update_billing_address_postcode: "",
          update_billing_address_city: "",
          update_billing_address_pays: "",

          update_delivery_address_address: "",
          update_delivery_address_address2: "",
          update_delivery_address_address3: "",
          update_delivery_address_postcode: "",
          update_delivery_address_city: "",
          update_delivery_address_pays: "",

          update_email_email: "",
          update_phone_phone: "",
          update_lastname_lastname: "",
          update_firstname_firstname: "",
        };
      },
    },
  };
</script>
